import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import { GlobalSaveService } from "../../../@core/global-save.service";
import {HttpClient} from "@angular/common/http";
import {UserInfoService} from "../../../@core/user-info.service";
import {DialogService} from "../../../../@util/dialog/dialog.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
	selector: 'app-global-save-cancel',
	templateUrl: './global-save-missing-follow-ups.component.html',
	styleUrls: ['../global-save-msg-form.component.scss']
})
export class GlobalSaveMissingFollowUpsComponent implements OnInit {
	title = 'StSr Message';

	globalSaveService;

	claimantName = '';

	constructor(
		private http: HttpClient,
		private userInfoService: UserInfoService,
		public dialog: MatDialog,
		private dialogRef: MatDialogRef<GlobalSaveMissingFollowUpsComponent>,
		@Inject(MAT_DIALOG_DATA) private data: any,
		private dialogService: DialogService,
		private route: ActivatedRoute,
		private router: Router) {

	}

	ngOnInit() {
		this.globalSaveService = new GlobalSaveService(this.http,this.userInfoService,this.dialog);

		this.claimantName = this.globalSaveService.getLastClaimanNameFullName();
	}

	closeVisitForm() {
		this.dialogRef.close();
	}

	goToFollowUp(){
		this.dialogRef.close({status:false});
		this.router.navigate(['/claimants/'+this.data.sslgId+'/follow-ups/pending']);
	}

	continueSave() {
		this.dialogRef.close({status:true});
	}
}
